// global Config */
// Vendor Libs
import {cloneDeep, get, omit, set} from 'lodash';

// Config
const initialState = {
    activeTabId: null,
    lastLayout: null,
    layouts: {},
};

const actions = {
    LAYOUT_REGISTER: (state, {dashboardName}) => ({
        ...state,
        lastLayout: dashboardName,
    }),

    LAYOUT_RESET: (state, {dashboardName}) => {
        const newState = cloneDeep(state);
        const name = dashboardName || state.lastLayout;

        return name ? set(newState, 'layouts', omit(newState.layouts, name)) : newState;
    },

    LAYOUT_UNREGISTER: (state, {dashboardName}) => {
        const newState = cloneDeep(state);

        return set(newState, 'layouts', omit(newState.layouts, dashboardName));
    },

    LAYOUT_UPDATE: (state, {dashboardName, layout, activeTabId}) => {
        const newState = cloneDeep(state);

        set(newState, ['layouts', dashboardName], layout);

        return {
            ...newState,
            activeTabId,
        };
    },

    PREFERENCES_LOAD: (state, {matureStores, stores}) => {
        const layouts = get(Config.base.matureContent ? matureStores : stores, 'layout.layouts');

        return layouts ? set(cloneDeep(state), 'layouts', layouts) : state;
    },

    PREFERENCES_RESET: () => cloneDeep(initialState),
};

const reducer = (state = initialState, action) => (actions[action.type] ? actions[action.type](state, action) : state);

export default reducer;
